// This function is used to rename data when it's used for the "More From This" component; it would be imported into the component where MoreFromThis component is also imported:
export const getMoreFromThisData = ({
    items,
    detailUrlPath,
    detailUrlPathReplace,
    type
}) => {
    // if no items, early return:
    if (!items) {
        return;
    }

    // map over items & create new data object;
    const newDataObject = items.map(item => {
        if (type === "photos") {
            // make src link for image:
            const detailLink = detailUrlPath.replace(
                detailUrlPathReplace,
                item.slugWithId
            );
            const {
                id,
                slugWithId,
                assets: { thumbnailSmall },
                title
            } = item;

            return {
                itemId: id,
                slugWithId,
                itemImage: thumbnailSmall,
                itemTitle: title,
                itemDetailUrl: detailLink
            };
        } else if (type === "icons") {
            const { url, thumbnails, title, id } = item;

            return {
                itemId: id,
                slugWithId: url,
                itemImage: thumbnails.thumbnail200,
                itemTitle: title,
                itemDetailUrl: item.url
            };
        } else {
            // we shouldnt actually get to this condition; this is just here just in case:
            return {
                itemId: "",
                slugWithId: "",
                itemImage: "",
                itemTitle: "",
                itemDetailUrl: ""
            };
        }
    });

    return newDataObject;
};
